import api from "@/lib/api";

export const authService = {
  register: (payload) => api.post("/auth/register", payload).then((r) => r.data),
  login: (payload) => api.post("/auth/login", payload).then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  validateCode: (code) => api.post("/auth/validate-code", { code }).then((r) => r.data),
  joinWaitlist: (email) => api.post("/auth/waitlist", { email }).then((r) => r.data),
};
